import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import messages from 'components/Apps/SensorsMonitor/translate'
import Filters from 'components/Apps/SensorsMonitor/FilterBar'
import Chart from 'components/Apps/SensorsMonitor/Chart'
import SummaryTable from 'components/Apps/SensorsMonitor/SummaryTable'
import WidgetContainer from 'components/Apps/WidgetContainer'
import 'styles/app/apps/sensorsMonitor/sensors-monitor.scss'
import CustomLimits from 'components/Apps/SensorsMonitor/CustomLimits'

class SensorsMonitor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isCustomLimitsActive: false,
    }
  }

  componentDidUpdate(prevProps) {
    const { activeTypes } = this.props
    const { isCustomLimitsActive } = this.state

    if (
      activeTypes !== prevProps.activeTypes &&
      activeTypes.size === 0 &&
      isCustomLimitsActive
    ) {
      this.setState({ isCustomLimitsActive: false })
    }
  }

  onOpenCustomLimitsForm = () => {
    this.setState({ isCustomLimitsActive: true })
  }

  onCloseCustomLimitsForm = () => {
    this.setState({ isCustomLimitsActive: false })
  }

  render() {
    const {
      intl: { formatMessage },
      activeTypes,
      currentApp,
      allowedToSetSensorsLimits,
    } = this.props
    const { isCustomLimitsActive } = this.state

    return (
      <div className="module sensors-module">
        <div className="module-head">
          <Typography className="module-title" variant="h5">
            {currentApp.name}
          </Typography>
          <Filters />
        </div>
        <div className="module-content">
          <Grid className="sensor-wrap" container spacing={2}>
            <Grid item lg={7} md={12} sm={12} xs={12}>
              <Paper className="sensor-list">
                <Chart />
              </Paper>
            </Grid>
            <Grid item lg={5} md={12} sm={12} xs={12}>
              <WidgetContainer
                name={formatMessage(
                  messages[isCustomLimitsActive ? 'maxLimits' : 'summary'],
                )}
                className="sensors-monitor">
                {isCustomLimitsActive && allowedToSetSensorsLimits ? (
                  <CustomLimits close={this.onCloseCustomLimitsForm} />
                ) : (
                  <SummaryTable />
                )}
                {activeTypes.size > 0 &&
                  !isCustomLimitsActive &&
                  allowedToSetSensorsLimits && (
                    <Button
                      className="set-limits-button"
                      color="primary"
                      variant="contained"
                      onClick={this.onOpenCustomLimitsForm}>
                      {formatMessage(messages.setLimits)}
                    </Button>
                  )}
              </WidgetContainer>
            </Grid>
          </Grid>
        </div>
      </div>
    )
  }
}

export default connect(state => ({
  activeTypes: state.getIn(['sensor', 'activeTypes']),
  allowedToSetSensorsLimits: state.getIn(
    ['profile', 'profile', 'grantedSetSensorsLimits'],
    true,
  ),
}))(injectIntl(SensorsMonitor))
